// SceneryKindRegistry — Set13 §4.11: the scenery-kind CATALOGUE, mirroring the material system's
// MaterialFuncRegistry. Holds the BUILT-IN root kinds; user kinds live on `Mod_TerrainSceneries`
// and the catalogue is the union, resolved at render time. Kinds are referenced by id (no closed
// union — a new kind is data + one generator function).
//
// This file is GLSL/mesh-free by design (the generator registry — which GEN_* builds which mesh —
// belongs with the worker). It only catalogues the authored DEFS. Each kind lives in its OWN file
// under `Kinds/` (the Recipe_* layout); editing a kind's params never touches this file — only
// adding/removing a kind does.
import type {SceneryKindDef} from "./@SceneryTypes.js";
import {ezTreeRootKind} from "./Kinds/Kind_EzTree.js";
import {builtInEzTreePresetKinds} from "./Kinds/Presets/@index.js";

// Order = a stable authoring order. The first entry is a reasonable UI default.
export const builtInSceneryKinds = new Map<string, SceneryKindDef>([
	// The ez-tree ROOT + its 15 generated preset kinds (Set14 P5 §4.8). The root is registered so
	// it's referenceable/forkable as a base even though it's a plain generic tree; the presets are
	// the "good-looking kinds on day one". `Pine Medium` replaces the deleted built-in pine kind.
	[ezTreeRootKind.id, ezTreeRootKind],
	...builtInEzTreePresetKinds.map(k=>[k.id, k] as [string, SceneryKindDef]),
]);

/** Built-in root kind ids. */
export const BUILT_IN_SCENERY_KIND_IDS: string[] = [...builtInSceneryKinds.keys()];

export function GetBuiltInSceneryKind(id: string): SceneryKindDef | undefined {
	return builtInSceneryKinds.get(id);
}
